import { render, staticRenderFns } from "./RegistroCompraAdmin.vue?vue&type=template&id=68a30e38"
import script from "./RegistroCompraAdmin.vue?vue&type=script&lang=js"
export * from "./RegistroCompraAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports